const billManagerStringsEN = {
  router: {
    error: {
      title: "This page isn't loading right now",
      body: "We're working on it.",
      backButton: 'Back',
      retryButton: 'Retry',
    },
  },
  productIntro: {
    title: 'ALL YOUR BILLS IN ONE PLACE',
    subtitle:
      'Your Bill Manager is active! Continue paying 5+ bills with Varo to maintain full access.',
    featureBullets: {
      calendar: 'Track everything in one calendar view',
      cancel: 'Cancel subscriptions anytime',
      alerts: 'Get alerts before bills are paid',
    },
    legalText:
      "By clicking 'Open Bill Manager' you're giving Varo permission to share your transaction data with Pinwheel to enable cross-account bill management.",
    linkTokenError: 'Something went wrong. Please try again.',
    cta: 'Open Bill Manager',
  },
  howToQualify: {
    title: 'TAKE CONTROL OF YOUR BILLS',
    subtitle:
      'From phone to streaming to utilities\u2014easily switch your bills to Varo and manage everything in one place.',
    sectionHeader: 'Move 5+ bills to Varo to get full access:',
    featureBullets: {
      calendar: 'Track everything in one calendar view',
      cancel: "Cancel subscriptions you don't want",
      alerts: 'Get alerts before bills are paid',
    },
    finePrint:
      'To maintain full access to Bill Manager, you must continue to pay 5+ bills with Varo.',
    linkTokenError: 'Something went wrong. Please try again.',
    cta: 'Move my bills',
  },
};

export default billManagerStringsEN;
